/// <reference path="../../../models/tableColumn.ts" />
import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PasswordConfirmationValidatorService } from '@services/custom-validators/password-confirm-validator.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { ChangePasswordRequest } from '../../../dto/changePasswordRequest';

@Component({
  selector: 'app-change-password-for-customer-dialog-content',
  templateUrl: './change-password-for-customer-dialog-content.component.html',
  styleUrls: ['./change-password-for-customer-dialog-content.component.scss'],
  providers: [FormService]
})
export class ChangePasswordDialogForCustomerContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'ChangePasswordDialogForCustomerContentComponent';

  public form: UntypedFormGroup;
  @Input() private customerId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private usersService: UsersService,
    private passwordConfirmValidator: PasswordConfirmationValidatorService,
    private activatedRoute: ActivatedRoute,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
      newPassword: new UntypedFormControl('', [Validators.required]),
      newPasswordConfirm: new UntypedFormControl(''),
    });

    this.formService.form.get('newPasswordConfirm').setValidators([Validators.required,
      this.passwordConfirmValidator.validateConfirmPassword(this.formService.form.get('newPassword'))]);
  }

  onSubmit(formValue) {
    const changePasswordRequest: ChangePasswordRequest = {
      newPassword: formValue.newPassword
    }

    this.usersService.changePasswordOfCustomer(changePasswordRequest, this.customerId).subscribe(result => {
      if (result.isSuccess) {
        this.messageService.setSuccess($localize`:@@ChangePasswordSuccess: Ihr Passwort wurde zurückgesetzt.`);
      }
    }, error => {
      this.messageService.setError(error);
    });
    
  }

}
